import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";

export const SuccessDialog = ({ open, guest, onDone }) => {
  const [left, setLeft] = useState(3);

  useEffect(() => {
    if (!open) return undefined;
    setLeft(3);
    const t = setInterval(() => setLeft((s) => s - 1), 1000);
    const done = setTimeout(onDone, 3000);
    return () => { clearInterval(t); clearTimeout(done); };
  }, [open, onDone]);

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onDone(); }}>
      <DialogContent className="glass-strong rounded-3xl max-w-sm text-center" data-testid="feedback-success-dialog">
        <motion.div initial={{ scale: 0, rotate: -30 }} animate={{ scale: 1, rotate: 0 }} transition={{ type: "spring", stiffness: 260, damping: 14 }} className="mx-auto h-20 w-20 rounded-full bg-emerald-100 grid place-items-center">
          <CheckCircle2 className="h-11 w-11 text-emerald-600" />
        </motion.div>
        <DialogTitle className="font-display text-2xl font-extrabold text-emerald-950">Feedback saved</DialogTitle>
        <DialogDescription className="text-slate-600">
          Thank you{guest ? `, ${guest}` : ""}! AI is analysing the response. Ready for the next guest in {Math.max(left, 0)}s.
        </DialogDescription>
        <button data-testid="success-next-guest-button" onClick={onDone} className="mt-2 h-11 rounded-full bg-emerald-900 text-amber-50 font-semibold hover:bg-emerald-800 transition-colors">
          Next guest now
        </button>
      </DialogContent>
    </Dialog>
  );
};
